import React from 'react';

import css from './MoreIcon.module.scss';

type EditIconProps = {
    onOpen: () => void;
    icon: string;
    customClassContainer?: string;
    customClassIcon?: string;
};

const MoreIcon = ({ onOpen, icon, customClassContainer, customClassIcon }: EditIconProps) => {
    const containerStyle = () => {
        let className = css.container;
        customClassContainer && (className += ' ' + customClassContainer);

        return className;
    };

    const iconStyle = () => {
        let className;
        customClassIcon && (className += ' ' + customClassIcon);

        return className;
    };

    return (
        <button className={containerStyle()} onClick={() => onOpen()}>
            <img className={iconStyle()} src={icon} alt="show more" />
        </button>
    );
};

export default MoreIcon;
